import { useState } from 'react';
import { apiFetch } from '../../hooks/apiFetch';
import { CartBooksSummary, CartOrdersSummary } from "../cart/CartSummery";
import { CartBooksItems, CartOrdersItmes } from "../cart/CartItems"
import Pagination from "../../utilities/Pagination";
import { allServicesCategories } from "../../data/CategoriesData"
// import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useUserCart } from '../../context/User/UserCartContext';
import { toast, ToastContainer } from 'react-toastify';
import SuccessErrorMsg from '../../utilities/SuccessErrorMsg';
// import { useForm } from 'react-hook-form';

export default function MyCart() {
    const [error, setError] = useState(null);
    // const { setValue } = useForm();
    const { t, i18n } = useTranslation();
    const {
        loading, cartBooks, setCartBooks, cartOrders, setCartOrders,
        cartStats, setCartStats, currentPageBooks, setCurrentPageBooks,
        currentPageOrders, setCurrentPageOrders, setLoading
    } = useUserCart();

    const totalPagesBooks = cartBooks?.data?.paginationInfo.totalPagesCount;
    const totalPagesOrders = cartOrders?.data?.paginationInfo.totalPagesCount;

    const allCartDataBooks = cartBooks?.data?.result;
    const allCartDataOrders = cartOrders?.data?.result;

    async function cartOrderDelete(data, orderId) {
        setLoading(true);

        try {
            const response = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/orders/${orderId}`, {
                method: "PATCH",
                body: JSON.stringify(data)
            });

            // Only update the order status, not the full page reload
            if (response.isSuccess) {
                // Update the local state instead of full page reload
                const updatedCartOrders = {
                    ...cartOrders,
                    data: {
                        ...cartOrders.data,
                        result: allCartDataOrders.map(order =>
                            order.id === orderId
                                ? { ...order, status: data.status }
                                : order
                        )
                    }
                };
                setCartOrders(updatedCartOrders);

                toast.info(t("OrderRemoveFromCart"));
                setError(null);
            } else {
                throw new Error(response.message || t("errorTryAgain"));
            }
        } catch (error) {
            console.error("Error during form submission: ", error); // Debug: Check error
            setError(t("errorTryAgain"));
            toast.error(t("errorTryAgain"));

        } finally {
            setLoading(false);
        }
    }

    async function cartBookDelete(id) {
        setLoading(true)
        try {
            const response = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/carts/book/${id}`, { method: "DELETE" });

            if (response.isSuccess) {
                const updatedCartData = {
                    ...cartBooks,
                    data: {
                        ...cartBooks.data,
                        result: allCartDataBooks.filter((item) => item.id !== id)
                    }
                };
                setCartBooks(updatedCartData);

                const deletedBook = allCartDataBooks.find(item => item.id === id);
                const updatedCartStats = {
                    ...cartStats,
                    data: {
                        totalBooks: (cartStats.data.totalBooks || 0) - (deletedBook?.quantity || 1),
                        totalBooksPrice: (cartStats.data.totalBooksPrice || 0) -
                            (deletedBook ? (deletedBook.book.price * deletedBook.quantity) : 0),
                        totalApprovedOrders: cartStats.data.totalApprovedOrders || 0
                    }
                };
                setCartStats(updatedCartStats);

                toast.info(t("BookRemoveFromCart"), {
                    autoClose: 2000,
                });

                setError(null);
            } else {
                throw new Error(response.message || t("errorTryAgain"));
            }
        } catch (err) {
            const errorMsg = t("errorDeleteBook") || "خطأ في حذف الكتاب";
            setError(errorMsg);
            toast.error(errorMsg, {
                autoClose: 3000,
                position: "top-right"
            });
            if (process.env.NODE_ENV === 'development') {
                console.error('Error deleting book:', err);
            }
        } finally {
            setLoading(false)
        }
    }

    if (error) {
        return <div className="text-center my-4 text-danger">{error}</div>;
    }

    if (!cartBooks) {
        return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    }

    return (
        <div className="container my-3 rounded bg-dark-beige pt-2 pb-3">
            <div className="d-flex flex-column flex-md-row">
                {loading ?
                    <div className="loader-orange col-12 col-md-9"></div>
                    :
                    <div className="d-flex flex-wrap justify-content-around">
                        {allCartDataBooks.map((item) => (
                            <CartBooksItems key={item.id}
                                bookTitle={item.book.title}
                                bookQty={item.quantity}
                                bookImg={item.book?.thumbnail}
                                bookImgAlt={item.book.createdAt}
                                bookPrice={item.book.price}
                                handleOnClick={() => cartBookDelete(item.id)}
                                t={t}
                            />
                        ))}

                    </div>
                }
                <CartBooksSummary
                    totalBooks={cartStats?.data?.totalBooks}
                    totalBooksPrice={cartStats?.data?.totalBooksPrice}
                    t={t} />
            </div>
            {totalPagesBooks > 1 &&
                <Pagination
                    currentPage={currentPageBooks}
                    setCurrentPage={setCurrentPageBooks}
                    totalPages={totalPagesBooks} />
            }
            <div className="d-flex flex-column flex-md-row bg-white rounded mb-3">
                {loading ?
                    <div className="loader-orange col-12 col-md-9"></div>
                    :
                    <div className="d-flex flex-wrap flex-column col-12 col-md-9">
                        {allCartDataOrders.map((item) => (
                            <CartOrdersItmes
                                key={item.id}
                                t={t}
                                orderService={
                                    allServicesCategories.map(cat =>
                                        cat.en === item.service?.name ?
                                            (i18n.language === "ar" ? cat.ar : cat.en) : "")}
                                orderPrice={item.offerDetails?.price}
                                handleOnClick={() => {
                                    // setValue("status", e.target.value);
                                    cartOrderDelete({ "status": "Rejected" }, item.id);
                                }}

                            />
                        ))}
                        {totalPagesOrders > 1 &&
                            <Pagination
                                currentPage={currentPageOrders}
                                setCurrentPage={setCurrentPageOrders}
                                totalPages={totalPagesOrders} />
                        }
                    </div>}
                <CartOrdersSummary
                    t={t}
                    totalOrders={cartStats?.data?.totalApprovedOrders}
                    totalOrdersPrice={cartStats?.data?.totalOrdersPrice} />
            </div>
            <SuccessErrorMsg
                ToastContainer={ToastContainer}
            />
        </div>
    );
};

// to Add 
// Ordar Approved or Rejected from user